import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

    inputValue: string;

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {titulo: string, descripcion?: string, input?: string, botonAceptar?: string, botonCancelar?: string}
    ) { }

    ngOnInit() {
        if (!this.data.descripcion) {
            this.data.descripcion = '';
        }
    }

    cerrarDialogo(resultado: boolean) {
        // if (!resultado || !this.data.input) {
        //     this.dialogRef.close(resultado);
        // } else {
        //     this.dialogRef.close(this.inputValue ?? '');
        // }

        if (!resultado) {
            this.dialogRef.close(false);
        } else if (this.data.input && !this.inputValue) {
            // Muestra un mensaje de validación en el HTML si es necesario
            return;
        } else {
            this.dialogRef.close(this.inputValue ?? true);
        }
    }

}
